var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"height":"100%"},attrs:{"to":{
		name: 'lesson',
		params: {
			lessonid: _vm.lesson.id,
		},
	},"elevation":"24"}},[(_vm.lesson.course_section)?_c('v-card-subtitle',{staticClass:"pb-0"},[_c('v-chip',{attrs:{"dark":"","small":""}},[_vm._v(" "+_vm._s(_vm.lesson.course_section.name)+" ")])],1):_vm._e(),_c('v-card-title',[_vm._v(" "+_vm._s(_vm.lesson.order)+". "+_vm._s(_vm.lesson.name)+" ")]),_c('v-card-text',[_c('small',[_vm._v("Додано "+_vm._s(_vm._f("formatDistanceToNow")(_vm.lesson.created_at)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }